import { render, staticRenderFns } from "./MultiInputField.vue?vue&type=template&id=af50267e&scoped=true"
import script from "./MultiInputField.vue?vue&type=script&lang=ts"
export * from "./MultiInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af50267e",
  null
  
)

export default component.exports